import { useQuery } from "@tanstack/react-query";
import { api } from "@/lib/api";
import CTAButtons from "@/components/CTAButtons";

export default function About() {
  const { data: homepage } = useQuery({ queryKey: ["homepage"], queryFn: () => api.get("/homepage").then((r) => r.data) });
  const a = homepage?.about || {};
  const stats = homepage?.stats || [];
  return (
    <div className="pt-32 pb-24">
      <div className="max-w-4xl mx-auto px-6 lg:px-10">
        <div className="text-xs uppercase tracking-[0.24em] text-amber-600 mb-4">About us</div>
        <h1 className="font-display text-5xl sm:text-6xl text-slate-950 leading-none">{a.title || "Journeys crafted with intention."}</h1>
        <p className="mt-8 text-slate-600 text-lg leading-relaxed">{a.body}</p>
      </div>
      {a.image_url && (
        <div className="max-w-6xl mx-auto px-6 lg:px-10 mt-16">
          <img src={a.image_url} alt="About" className="w-full aspect-[16/7] object-cover rounded-2xl" />
        </div>
      )}
      <div className="max-w-7xl mx-auto px-6 lg:px-10 mt-20 grid grid-cols-2 md:grid-cols-4 gap-6">
        {stats.map((s, i) => (
          <div key={i} className="border border-slate-200 rounded-xl p-6 bg-white">
            <div className="font-display text-4xl text-slate-950">{s.value}</div>
            <div className="text-xs uppercase tracking-[0.24em] text-slate-500 mt-2">{s.label}</div>
          </div>
        ))}
      </div>
      <div className="max-w-4xl mx-auto px-6 lg:px-10 mt-20">
        <CTAButtons label="a personalised journey" sourceRef="about" testIdPrefix="about" />
      </div>
    </div>
  );
}
